import axios from "axios";

export const servicesAPI = {
  register(formData: FormData) {
    return axios.post("/auth/register/", formData).then((res) => res.data);
  },
  login(formData: FormData) {
    return axios.post("/auth/token/", formData).then((res) => res);
  },
  getHotels() {
    return axios.get("/api/v1/hotel/").then((res) => res.data);
  },
  getCars() {
    return axios.get("/api/v1/car/").then((res) => res.data);
  },
  getExcursions() {
    return axios.get("/api/v1/tour/").then((res) => res.data);
  },
  getExcursionsLanguages() {
    return axios.get("/api/v1/tour_language/").then((res) => res.data);
  },
};
